import constants from '../../../../../appConstants';
import { MultiSelectFilter, DateTimeFilter, StaticFilter } from '@dataGrid/components/columnFilters';
import { mergeUserConfig, roundingNumbersWithoutTrailingZeros,formatDateTime } from '@dataGrid/gridUtilities';
import { getSpecialNeeds, SpecialNeedsRenderer } from '@dataGrid/components/cellRenderer';
import PreDispatchButtonRenderer from './PreDispatchButtonRenderer';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration({ userProfile } = {}) {
    const defaultConfig = GridConfig.getDefaultConfiguration(userProfile);
    const userConfig = userProfile?.columnPref;
    return mergeUserConfig({
      defaultConfig,
      userConfig,
    });
  }

  static getSpecialNeedsOption(params) {
    return params.context.specialNeedsOptions;
  }

  static getDefaultConfiguration(userProfile) {
    return {
      title: constants.gridNames.ClosedTrailersGrid,
      keyColumn: 'trailerId',
      rowSelection: 'single',
      rowDeselection: true,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        editable: false,
      },
      columns: [
        {
          headerName: 'Route #',
          headerTooltip: 'Route Name',
          field: 'routeName',
          minWidth: constants.columnWidth.ROUTES,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
        },
        {
          headerName: 'Trailer #',
          headerTooltip: 'Trailer Number',
          field: 'trailerNumber',
          minWidth: constants.columnWidth.W_150,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
        },
        {
          headerName: 'Trailer Status',
          headerTooltip: 'Trailer Status',
          field: 'trailerStatus',
          minWidth: constants.columnWidth.STATUS,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
        },
        {
          headerName: 'Trailer Type',
          headerTooltip: 'Trailer Type',
          field: 'trailerType',
          minWidth: constants.columnWidth.W_130,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          filterParams: {
            filterType: constants.FILTER_TYPES.STRING,
          },
        },
        {
          headerName: 'Route Start Time',
          headerTooltip: 'Planned Route Start Time',
          field: 'plannedRouteStartTime',
          minWidth: constants.columnWidth.W_140,
          cellClass: 'gridCell-leftAlign',
          filter: DateTimeFilter,
        },
        {
          headerName: "Driver",
          field: "driverName",
          minWidth: constants.columnWidth.W_160,
          editable: true,
          headerTooltip: "Driver Name",
          cellClass: "gridCell-leftAlign",
          filter: MultiSelectFilter,
          cellRenderer: PreDispatchButtonRenderer
        },
        {
          headerName: 'Ttl Stops',
          field: 'totalStops',
          headerTooltip: 'Total Stops',
          minWidth: constants.columnWidth.W_90,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
        },
        {
          headerName: 'Weight',  
          field: 'totalWeight',
          headerTooltip: 'Total Weight',
          minWidth: constants.columnWidth.W_90,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
        },
        {
          headerName: 'PSE',
          field: 'totalPse',
          headerTooltip: 'Total PSE',
          minWidth: constants.columnWidth.W_90,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          valueFormatter: roundingNumbersWithoutTrailingZeros,
        },
        {
          headerName: 'Ttl Pro(s)',
          field: 'numberOfProsLoaded',
          minWidth: constants.columnWidth.W_90,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
        },
        {
          headerName: 'Manifest #',
          headerTooltip: 'Manifest Number',
          field: 'manifestNumber',
          minWidth: constants.columnWidth.MANIFEST_ID,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
        },
        {
          headerName: 'Trailer Close Time',
          headerTooltip: 'Trailer Close Time',
          field: 'trailerClosedTime',
          minWidth: constants.columnWidth.CLOSE_TIME,
          cellClass: 'gridCell-leftAlign',
          filter: DateTimeFilter,
          filterParams: {
            DATETYPE: constants.DATETYPES.DATETIME
          },
          valueFormatter: formatDateTime,
        },
        {
          headerName: 'Paper DR',
          field: 'physicalDrCount',
          minWidth: constants.columnWidth.W_80,
          headerTooltip: 'Total Paper DR pros',
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
        },
        {
          headerName: 'Spl Needs',
          headerTooltip: 'Special Needs',
          minWidth: constants.columnWidth.SPL_NEED,
          cellClass: 'gridCell-leftAlign',
          valueGetter: getSpecialNeeds,
          cellRenderer: SpecialNeedsRenderer,
          filter: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getSpecialNeedsOption,
          },
        }
      ],
    };
  }
}

